import { createPortal } from 'react-dom';
import { Loader } from '../Common/Loader';
import { useTranslate } from '@/hooks/useTranslate';
import { PaymentMethodEnum } from '@/types/common';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const MbwayAuthorizationScreen = () => {
  const { t } = useTranslate();

  // Portaled to document.body so `fixed inset-0` anchors to the viewport. The
  // checkout Modal's transformed ancestor would otherwise become the containing
  // block and trap the overlay inside the payment column (see SuccessScreen).
  return createPortal(
    <div
      data-testid="mbway-authorization-screen"
      className="fixed inset-0 bg-base-black/60 backdrop-blur-sm flex items-center justify-center z-150 p-4"
      role="status"
      aria-live="polite"
    >
      <div className="bg-white rounded-[var(--radius-xl)] p-8 shadow-xl w-full max-w-[320px]">
        <div className="flex flex-col items-center gap-4 text-center">
          <img src={getPaymentMethodLogoUrl(PaymentMethodEnum.MBWAY)} alt="MB WAY" className="h-6" />
          <Loader size="lg" variant="checkout" />
          <p className="text-lg font-medium text-card-foreground">{t('mbwayApprovalTitle')}</p>
          <p className="text-sm text-muted-foreground">{t('mbwayApprovalSubtitle')}</p>
        </div>
      </div>
    </div>,
    document.body
  );
};
